import DropdownControl from "../../../../../shared/ui/form/DropdownControl";
import CheckboxField from "../../../../../shared/ui/field/CheckboxField";
import {FilterCheckboxListFieldType, FilterFieldTypeEnum} from "../../../model/filter-types";
import {OnChangeFilterHandler} from "../../../model/useFilterHandler";

interface IProps {
    keyField: string;
    field: FilterCheckboxListFieldType;
    filedState: string[] | number[];
    onChangeHandler: OnChangeFilterHandler;
}

/**
 * Компонент для отображения выпадающего списка чекбоксов (checkbox list).
 * Используется для фильтров с множественным выбором, таких как категории, бренды, теги и т.д.
 *
 * Формирует список на основе `field.data`, где ключ — значение фильтра, а значение — количество товаров.
 * Каждому элементу списка соответствует чекбокс.
 *
 * @param keyField - Ключ фильтра (идентификатор поля)
 * @param field - Конфигурация поля фильтра (заголовок, список значений и их count)
 * @param filedState - Текущее состояние выбранных значений фильтра
 * @param onChangeHandler - Универсальный обработчик изменения значения
 *
 * @returns JSX-элемент DropdownControl с чекбоксами внутри
 */
const FilterCheckboxList = ({keyField, field, filedState, onChangeHandler}: IProps) => {
    const items = Object.entries(field.data).map(([key, count]) => ({
        value: key,
        title: `${key} (${count})`
    }));

    return (
        <DropdownControl slotHeader={<>{field.title}</>}
                         slotContent={<>
                             {items.map(item => {
                                 const state = Array.isArray(filedState) ? filedState : [];
                                 //@ts-ignore
                                 const checked = state.includes(item.value);
                                 return (
                                     <DropdownControl.Item key={item.value}>
                                         <CheckboxField
                                             checked={checked}
                                             onChange={() => {
                                                 onChangeHandler(item.value, keyField, FilterFieldTypeEnum.checkbox_list);
                                             }}
                                             label={item.title}
                                             name={keyField}
                                         />
                                     </DropdownControl.Item>
                                 );
                             })}
                         </>}/>

    );
};

export default FilterCheckboxList;